exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".contactModal{color:#555}.contactModal .wrModalBody{padding:0!important}.contactModal .errorDisplay{padding-left:50px}.contactModal .messageArea{height:150px;width:350px;margin:auto}.contactModal .buttonSuccess{width:150px}.contactModal .wrModalHeader{margin-right:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/support/support_page.scss
// module id = 1382
// module chunks = 0